//Import
import React, { useEffect, useReducer, useState } from "react";

// Component Composition
import GroupHeader from "../../components/GroupHeader";
import GroupTableHeader from "../../components/GroupTableHeader";
import GroupTableContainer from "../../components/GroupTableContainer";
import GroupFormContainer from "../../components/GroupFormContainer";
import NavBar from "../../components/NavBar";

import {
  cierresRutasReducer,
  cierresRutasInitialState,
} from "../../reducers/cierresRutasReducer";
import { URL_BASE_API } from "../../settings/urlBaseApi";
import { Modal as ModalAnt } from "antd";
import { deleteToken, helpHttp } from "../../helpers/helpHtpp";
import { types } from "../../types/types";
import Mensaje from "../../components/Mensaje/Mensaje";
import Loader from "../../components/Loader/Loader";
import { message } from "antd";
import ModalPdfCierre from "../../components/ModalPdfCierre/ModalPdfCierre";

// Componente base
const CierresView = ({ ...props }) => {
  const [state, dispatch] = useReducer(
    cierresRutasReducer,
    cierresRutasInitialState
  );
  const [modalPdfCierreVisible, setModalPdfCierreVisible] = useState(false);
  const [listadoCierres, setListadoCierres] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const seguro = localStorage.getItem("seguro");

  const {
    totalCobro,
    totalGastos,
    totalCreditos,
    totalSeguro,
    totalDevoluciones,
    caja,
    totalCierre,
    totalSaldados,
    cajaInicial,
    fechaCajaInicial,
    totalMora,
    totalEfectivo,
    totalBanco,
  } = state;

  const hoy = new Date();

  const handleAplicarCierre = (e) => {
    e.preventDefault();
    ModalAnt.confirm({
      title: `Aplicar Precierre`,
      content: `¿Está seguro de aplicar el precierre para la fecha ${hoy.toLocaleDateString()}, después no podra ingresar más a la empresa hasta el siguiente día?`,
      cancelText: "Cancelar",
      okText: "Aplicar",
      onOk: () => aplicarPrecierre(),
    });
  };

  const handleVerPdfMora = (e) => {
    e.preventDefault();
    ModalAnt.confirm({
      title: `Aplicar Precierre`,
      content: `¿Desea ver el PDF de Mora?`,
      cancelText: "Cancelar",
      okText: "Ver PDF Mora",
      onOk: () => verPdfMora(),
    });
  };

  const verPdfMora = async () => {
    setLoading(true);
    setError(null);

    const urlLinkPDF = `${URL_BASE_API}/cierres-rutas/pdf/mora`;

    try {
      // 1. Obtener la ruta del archivo desde tu API
      const res = await helpHttp().get(urlLinkPDF);

      if (res.err) throw new Error("Error en la respuesta de la API");

      // 2. Consultar el CDN para descargar el PDF como Blob
      const urlCdn = `https://ofinec-cdn.sfo3.digitaloceanspaces.com/${res.soporte_mora}`;
      const response = await fetch(urlCdn, { method: "GET", redirect: "follow" });

      if (response.status !== 200) throw new Error("Error al descargar desde el CDN");

      // 3. Crear el ObjectURL y abrir el PDF
      const blob = await response.blob();
      const fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL);

    } catch (error) {
      // Centralización del manejo de errores
      console.error(error);
      message.error({ content: "Hubo un error" });
    } finally {
      // Se ejecuta siempre, sin importar si falló o tuvo éxito
      setLoading(false);
    }
  };

  const closeModalPdfCierre = (e) => {
    e.preventDefault();
    setModalPdfCierreVisible(false);
  };

  const aplicarPrecierre = () => {
    let url = URL_BASE_API + "/cierres-rutas";
    setLoading(true);
    helpHttp()
      .post(url, {
        body: {
          totalCobro,
          totalGastos,
          totalCreditos,
          totalSeguro,
          totalDevoluciones,
          caja,
          totalCierre,
          totalSaldados,
        },
      })
      .then((res) => {
        if (res !== undefined) {
          if (!res.err) {
            setError(null);
            message.success({
              content: `El precierre para la fecha ${hoy.toLocaleDateString()} fue aplicado!`,
            });
            setTimeout(function () {
              deleteToken();
              window.location = "/#/mensaje-error/ruta-cerrada";
            }, 3000);
          } else {
            message.error({
              content: `Hubo un error, el precierre para la fecha ${hoy.toLocaleDateString()} no fue aplicado!`,
            });
          }
        }
        setLoading(false);
      });
  };

  let url = URL_BASE_API + "/cierres-rutas";
  useEffect(() => {
    let isMounted = true;

    setLoading(true);

    helpHttp()
        .get(url)
        .then((res) => {
          if (!isMounted) return; // 🔥 evita ejecutar si ya se desmontó

          if (!res.err) {
            setError(null);
            dispatch({
              type: types.cierres_rutas_todos,
              payload: res,
            });
          } else {
            setError(res);
          }

          setLoading(false);
        })
        .catch((err) => {
          if (!isMounted) return;

          setError(err);
          setLoading(false);
        });

    return () => {
      isMounted = false;
    };
  }, [url]);

  const handlePdfCierre = () => {
    peticionHttpListadoCierres();
    setModalPdfCierreVisible(true);
  };

  const handleClickVerPdf = (e, cierre) => {
    e.preventDefault();

    ModalAnt.confirm({
      title: `PDF Cierre diario`,
      content: `¿Desea ver el PDF de cierre diario para la fecha ${cierre.fecha}?`,
      cancelText: "Cancelar",
      okText: "Ver PDF",
      onOk: () => handleClickVerPdfPeticion(cierre),
    });
  };

  const handleClickVerPdfPeticion = (cierre) => {
    let url =
      "https://ofinec-cdn.sfo3.digitaloceanspaces.com/" + cierre.soporte;
    setLoading(true);

    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(url, requestOptions).then((response) => {
      if (response.status === 200) {
        setError(null);
        response.blob().then((blob) => {
          const fileURL = window.URL.createObjectURL(blob);
          window.open(fileURL);
        });
      } else {
        message.error({
          content: `Hubo un error`,
        });
      }
      setLoading(false);
    });
  };

  const peticionHttpListadoCierres = () => {
    setListadoCierres(null);
    setLoading(true);
    let url = URL_BASE_API + "/cierres-rutas/pdf/cierre-diario";
    helpHttp()
      .get(url)
      .then((res) => {
        if (!res.err) {
          setError(null);
          setListadoCierres(res);
        } else {
          message.error({
            content: `Hubo un error`,
          });
        }
        setLoading(false);
      });
  };

  return (
    <div {...props}>
      <GroupHeader category="Cierres" busqueda={false} />
      <ModalPdfCierre
        show={modalPdfCierreVisible}
        opacity="0.8"
        w={"20em"}
        closeModal={closeModalPdfCierre}
        listadoCierres={listadoCierres}
        handleClickVerPdf={handleClickVerPdf}
      ></ModalPdfCierre>
      <GroupTableContainer>
        <GroupTableHeader
          section={hoy.toLocaleDateString()}
          enrutar={true}
          sectionEnrutar="PDF Cierre"
          handleEnrutar={handlePdfCierre}
        />
        <GroupFormContainer
          totalMora={totalMora}
          totalCobro={totalCobro}
          totalGastos={totalGastos}
          totalCreditos={totalCreditos}
          totalSeguro={totalSeguro}
          totalDevoluciones={totalDevoluciones}
          totalCierre={totalCierre}
          totalSaldados={totalSaldados}
          cajaInicial={cajaInicial}
          fechaCajaInicial={fechaCajaInicial}
          caja={caja}
          totalBanco={totalBanco}
          totalEfectivo={totalEfectivo}
          handleAplicarCierre={handleAplicarCierre}
          handleVerPdfMora={handleVerPdfMora}
          disabled={true}
          seguro={seguro}
        />
      </GroupTableContainer>
      {error && (
        <Mensaje
          mensaje={`Error ${error.status}: ${error.statusText}`}
          type="error"
          title="Error"
        />
      )}
      {loading && <Loader />}
      <NavBar view="cierres" />
    </div>
  );
};

export default CierresView;
